import BrandsApi from '../../apis/Brands'

export default {
    namespaced: true,
    state: {
        brands: [],
        categorias: [],
        marcas: [],
        unidadMedidas: [],
        categoria_id:null,
        marca_id: null,
        unidadMedida_id: null,
        tipoProductos:[
            'MATERIAL', 'REACTIVO'
        ],
        tipoProducto: null
    },
    mutations: {
        set_brands (state, brands) {
            state.brands = brands
        },
        set_categoria (state, categoria) {
            state.categorias = categoria
        },
        set_marca (state, marca) {
            state.marcas = marca
        },
        set_unidadMedida (state, unidadMedida) {
            state.unidadMedidas = unidadMedida
        },
        set_categoria_id (state, categoria_id) {
            state.categoria_id = categoria_id
        },
        set_marca_id (state, marca_id) {
            state.marca_id = marca_id
        },
        set_unidadMedida_id (state, unidadMedida_id) {
            state.unidadMedida_id = unidadMedida_id
        },
        set_tipoProducto(state, tipoProducto){
            state.tipoProducto = tipoProducto
        }
    },
    actions: {
        async getBrands({commit, dispatch}, filters) {
            return await BrandsApi.get_all(filters)
                        .then( response => {
                            commit('set_brands', response.data)
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async store({dispatch}, brand) {
            return await BrandsApi.store(brand)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'El registro se realizó de forma correcta.'
                                }, {root: true});
                                dispatch('getBrands')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al registrar, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async update({dispatch}, brand) {
            return await BrandsApi.update(brand)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La actualización se realizó de forma correcta'
                                }, {root: true});
                                dispatch('getBrands')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al actualizar, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async change_status({dispatch}, brand) {
            let action = (brand.active) ? 'inactivación' : 'activación';
            return await BrandsApi.change_status(brand)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La ' + action + ' se relizó de forma correcta.'
                                }, {root: true});
                                dispatch('getBrands')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async delete({dispatch}, brand) {
            return await BrandsApi.delete(brand)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La eliminación se realizó de forma correcta.'
                                }, {root: true});
                                dispatch('getBrands')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
    }
}